import React from 'react';
import humanizeString from 'humanize-string';
import Toggle from 'components/toggle';
import PropTypes from 'prop-types';
import { fieldUniqueIdentifier, INFO_TEXT } from './helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export default function FieldSection({
  fieldsForKey,
  modifiedFields,
  removeModelFieldTooltip,
  sectionName,
  onFieldChanged
}) {
  function stringSort(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  function showInfoTooltip(fieldName) {
    return !removeModelFieldTooltip.includes(fieldName);
  }

  return (
    <React.Fragment>
      <tr className="position-sticky" style={{ top: '-1px', zIndex: 1 }}>
        <td className="ds-bg-light-grey ds-text-muted fw-bold text-uppercase" colSpan={3}>
          {humanizeString(sectionName)}
        </td>
      </tr>

      {fieldsForKey.toSorted(stringSort).map((field) => {
        const uniqueIdentifier = fieldUniqueIdentifier(field);
        const toggleChecked = (modifiedFields[uniqueIdentifier]?.status || field.status) === 'required_field';
        return (
          <tr key={uniqueIdentifier}>
            <td>
              <div className="d-flex gap-2 align-items-center">
                {field.label}
                {showInfoTooltip(field.fieldName) && <InfoText field={field} />}
              </div>
            </td>
            <td>{field.fieldType}</td>
            <td>
              <div className="d-flex align-items-center gap-3">
                <Toggle
                  checked={toggleChecked}
                  disabled={!field.isToggleable}
                  theme="ds"
                  onChange={() => onFieldChanged(field, toggleChecked)}
                />
                {!field.isToggleable && (
                  <span>Required for Buildout</span>
                )}
              </div>
            </td>
          </tr>
        );
      })}
    </React.Fragment>
  );
}

function InfoText({ field }) {
  const infoText = INFO_TEXT[field.nameOfModel]?.[field.fieldName];
  if (!infoText) return null;

  const tooltip = (
    <Tooltip id={`${infoText.fieldName}-${infoText.nameOfModel}`}>{infoText}</Tooltip>
  );

  return (
    <OverlayTrigger overlay={tooltip} placement="bottom">
      <FontAwesomeIcon icon={faInfoCircle} size="lg"/>
    </OverlayTrigger>
  );
}

const fieldShape = PropTypes.shape({
  fieldName: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
  isToggleable: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  nameOfModel: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired
});

InfoText.propTypes = {
  field: fieldShape.isRequired
};

export const baseFieldsArrayShape = PropTypes.arrayOf(fieldShape);

FieldSection.propTypes = {
  fieldsForKey: baseFieldsArrayShape,
  modifiedFields: PropTypes.object,
  removeModelFieldTooltip: PropTypes.array,
  sectionName: PropTypes.string.isRequired,
  onFieldChanged: PropTypes.func.isRequired
};
